import 'babel-polyfill'


// WEBPACK FOOTER //
// polyfills.js